enum ErrorVinculate {
  FB001 = 'NOW_LETS_CONNECT_TO_FACEBOOK',
  FB004 = 'HOW_CONNECT_FACEBOOK_PAGE_TO_INSTAGRAM',
  'no-fb-pages' = 'HOW_CONNECT_FACEBOOK_PAGE_TO_INSTAGRAM',
  'no-fb-pages-linked' = 'HOW_CONNECT_FACEBOOK_PAGE_TO_INSTAGRAM',
}

export default ErrorVinculate
